import { render } from "./TableComponent.vue?vue&type=template&id=3005791a&scoped=true"
import script from "./TableComponent.vue?vue&type=script&lang=js"
export * from "./TableComponent.vue?vue&type=script&lang=js"

import "@/assets/css/general/table-style.css?vue&type=style&index=0&id=3005791a&scoped=true&lang=css&external"
import "@/assets/css/general/form-style.css?vue&type=style&index=1&id=3005791a&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3005791a"]])

export default __exports__